module.exports = __webpack_public_path__ + "static/media/plus.d814ed09.svg";